import { useServicesContext } from "@/modules/core/services/services.context"
import { UserEntity } from "@/modules/profile/userProfile/userEntity"
import { socialKeys } from "@/modules/social/gateway/socialKeys"
import { useInfiniteQuery } from "@tanstack/react-query"

export const useSocialMentionableUsers = (socialPostId: string | null, filter: string) => {
  const { socialApi } = useServicesContext()

  const query = useInfiniteQuery({
    queryKey: socialKeys.mentionableUsers(socialPostId ?? "", filter),
    queryFn: async ({ pageParam }) => {
      const dto = await socialApi.getMentionableUsers(socialPostId!, filter, pageParam, 10)
      return {
        ...dto,
        content: dto.content.map((u) => UserEntity.fromDto(u)),
      }
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.page + 1),
    enabled: !!socialPostId && filter.length > 0,
    placeholderData: (prev) => prev,
  })

  const users = query.data?.pages.flatMap((p) => p.content) ?? []

  return { ...query, users }
}
